module.exports = __webpack_public_path__ + "static/media/exercises-step7.c54471e2.png";